import React,{useEffect, useRef} from 'react'
import InventoryTransactionList from '../components/InventoryTransactionList';

import FinanceLayout from '../../../../../../layout/components/FinanceLayout';


function InventoryTransactionsPage() {
	return (
		<FinanceLayout>
			<div className='row'>
				<div className='col-md-12 mt-2'>
					<InventoryTransactionList />
				</div>
			</div>
		</FinanceLayout>
  	)
}

export default InventoryTransactionsPage